@if (type === 'h4') {
  <h4 [class]="'m-0 text-wrap ' + class" appTranslate>{{ title }}</h4>
}
@if (type === 'h5') {
  <h5 [class]="'m-0 text-wrap ' + class" appTranslate>{{ title }}</h5>
}
@if (type === 'h6') {
  <h6 [class]="'m-0 text-wrap ' + class" appTranslate>{{ title }}</h6>
}
